import './Button.css';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  disabled,
  fullWidth,
  onClick,
  title,
  type = 'button',
  className = '',
}) {
  return (
    <button
      type={type}
      className={`btn btn--${variant} btn--${size}${fullWidth ? ' btn--full' : ''} ${className}`}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      {icon && <span className="btn__icon">{icon}</span>}
      {children && <span className="btn__label">{children}</span>}
    </button>
  );
}
